<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          header="Create FAQ"
        >
          <b-row v-if="userRole === 'Tenant'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="scope"
                :options="scopeOptions"
                label="label"
                placeholder="Select scope"
              ></eb-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Category</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="category"
                :options="categoryOptions"
                label="label"
                placeholder="Select category"
              ></eb-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Topic</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-input
                  class="custom-transform-class"
                  inputType="text"
                  placeholder="Topic"
                  v-model="topic"
                />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <span>Description</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-textarea
                  v-model="description"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Media Type</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="mediatype"
                :options="mediaOptions"
                label="label"
                @select="onSelect"
                placeholder="Select Media Type"
              ></eb-select>
            </b-col>
          </b-row>
          <b-row
            v-if="
              this.mediatype == 'VIDEO' ||
              this.mediatype == 'IMAGE' ||
              this.mediatype == 'DOCUMENT'
            "
          >
            <b-col md="4">
              <span>Upload Media</span>
            </b-col>
            <b-col md="8">
              <b-form-file
                @change="changePhoto"
                :state="Boolean()"
                placeholder="Choose a Media..."
                drop-placeholder="Drop Media here..."
              ></b-form-file>
            </b-col>
          </b-row>
          <hr />
          <div class="text-center mt-3 mb-3">
            <eb-button
              classic="mr-1 btn-primary"
              text="Back"
              @click="e => $emit('created', e)"
            ></eb-button>
            <eb-button
              class="btn mr-4"
              classic="mr-1 btn-primary"
              text="Save"
              @click.prevent="handleSubmit"
            ></eb-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from '@/components/Common/CustomInput';
import { shuffleArray } from '@/shared/utils';
import ebSelect from '@/components/FormElements/Select.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import ebButton from '@/components/FormElements/Button';
import faqdetails from '@/components/MasterSetup/FAQ/FAQDetails.vue';

export default {
  name: 'createfaq',
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
  },

  data: () => {
    return {
      show: true,
      mediatype: '',
      photo: '',
      scope: '',
      mediaOptions: ['VIDEO', 'IMAGE', 'DOCUMENT'],
      categoryOptions: ['Property', 'Unit'],
      scopeOptions: ['PARTNER', 'CUSTOMER'],
      category: '',
      topic: '',
      description: '',
      //     form:{
      // 	tenant: this.$store.getters["auth/getUserID"],
      //     category: "",
      //     item: {
      //         topic: "",
      //         description: ""
      //     }
      // },
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters['auth/getUserRole']) {
        return this.$store.getters['auth/getUserRole'];
      } else {
        return JSON.parse(sessionStorage.getItem('userLogin'))['role'];
      }
    },
  },
  methods: {
    onSelect() {
      if (this.mediatype == 'image') {
        console.log(this.mediatype);
        show = 'false';
      }
    },
    changePhoto(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.photo = reader.result;
        this.$emit('readIMG', this.img);
      };
      reader.onerror = err => {
        console.error('reader : ', err);
      };
    },
    handleSubmit() {
      let dataObj;
      if (
        JSON.parse(sessionStorage.getItem('userLogin'))['role'] === 'Tenant'
      ) {
        dataObj = {
          category: this.category,
          scope: this.scope,
          item: {
            topic: this.topic,
            description: this.description,
            media: {
              mediaType: this.mediatype,
              mediaContent: this.photo,
            },
          },
        };
      } else {
        dataObj = {
          category: this.category,
          scope: 'TENANT',
          item: {
            topic: this.topic,
            description: this.description,
            media: {
              mediaType: this.mediatype,
              mediaContent: this.photo,
            },
          },
        };
      }
      this.$store.dispatch('faq/createFaq', dataObj).then(() => {
        this.$swal({
          title: 'Success',
          text: 'Faq added successfully!!',
          type: 'success',
        });
        this.$emit('created', {});
        this.$store.dispatch(
          'faq/fetchFaqsList',
          this.$store.getters['auth/getUserID']
        );
      });
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
